import { Controller } from "@hotwired/stimulus"

// Pure client-side selection highlight for the Track Time panel's
// timeline: the clicked block gets the selected ring, every other block
// loses it. The actual detail load is the block link's turbo-frame
// navigation; this only mirrors it visually. The running block is the
// `running` target, not a row target (the detail pane defaults to it),
// but its click still clears the selected blocks.
const SELECTED_CLASSES = ["time-tracking-selected"]

export default class extends Controller {
  static targets = ["row", "running"]

  // The detail pane preloads a session (the running one, else the most
  // recent — PanelComponent#detail_session); mirror that in the list so
  // the panel never opens with nothing marked active. The running card
  // already reads as active through its permanent primary styling, so the
  // first-row highlight only applies without one.
  connect() {
    if (this.hasRunningTarget) return
    if (this.rowTargets.some((el) => el.classList.contains(SELECTED_CLASSES[0]))) return

    this.rowTargets[0]?.classList.add(...SELECTED_CLASSES)
  }

  select(event) {
    const row = event.currentTarget.closest("[data-time-tracking-selection-target='row']")
    this.rowTargets.forEach((el) => {
      SELECTED_CLASSES.forEach((klass) => el.classList.toggle(klass, el === row))
    })
  }
}
